// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "apexcharts" + "." + "964bbb43d4d5e74a" + ".js";
};